import '../css/visit_memo.scss';

const storageKey = 'petter.visitMemo.v1';
const ttl = 24 * 60 * 60 * 1000;
const fields = {
  pet_name: '名前', species: '種類', age: '年齢', observed_on: 'メモの日付',
  concern: 'いちばん気になる変化', onset: 'いつから・頻度',
  daily_life: '食欲・水分・便・尿の変化', medication: '薬・持病・アレルギー',
  questions: '先生に聞きたいこと'
};

document.querySelectorAll('[data-print]').forEach(button => {
  button.addEventListener('click', () => window.print());
});
// Reload bfcache restores so a previous account's authenticated controls cannot be reused.
window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistration().then(registration => registration && registration.update()).catch(() => {});
}

const root = document.getElementById('visit-memo');
if (root) initialize();

function initialize() {
  const form = document.getElementById('vm-form');
  const status = document.getElementById('vm-status');
  const editor = document.getElementById('vm-editor');
  const preview = document.getElementById('vm-preview');
  const photoInput = document.getElementById('vm-photos');
  let photos = [];
  let photoVersion = 0;
  let photoBusy = false;
  let requestId = randomId();
  let expiresAt = Date.now() + ttl;
  let saving = false;
  let eventQueue = Promise.resolve();
  let started = false;

  function notice(message) { status.textContent = message; }
  function values() {
    const data = new FormData(form);
    return Object.keys(fields).concat(['pet_id']).reduce((result, key) => {
      result[key] = String(data.get(key) || '').trim();
      return result;
    }, {});
  }
  function persist(isPreview = !preview.hidden) {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        values: values(), photos, requestId, expiresAt, isPreview,
        owner: root.dataset.userId || null
      }));
      return true;
    } catch (_) {
      notice('このブラウザでは一時保存できません。ページを離れる前に印刷・PDFで保管してください。');
      return false;
    }
  }
  async function send(url, data) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    try { return await fetch(url, {
      method: 'POST', credentials: 'same-origin',
      signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      body: JSON.stringify(data)
    }); } finally { window.clearTimeout(timeout); }
  }
  function track(name) {
    // Serialize events so start reaches the server before complete (cookie session ordering).
    eventQueue = eventQueue.then(() => send(root.dataset.eventsUrl, { event_name: name })).catch(() => {});
    return eventQueue;
  }
  function start() {
    if (!started) { started = true; track('visit_memo_start'); }
  }
  function showPreview(focus = true) {
    if (!form.reportValidity()) return;
    if (photoBusy) { notice('写真の準備が終わるまでお待ちください。'); return; }
    if (!values().concern) { notice('気になる変化を入力してください。'); return; }
    start();
    const summary = document.getElementById('vm-summary');
    summary.replaceChildren();
    Object.entries(fields).forEach(([key, label]) => {
      const group = document.createElement('div');
      const title = document.createElement('dt');
      const body = document.createElement('dd');
      title.textContent = label;
      body.textContent = values()[key] || '未記入';
      group.append(title, body);
      summary.append(group);
    });
    renderPhotos(document.getElementById('vm-preview-photos'), false);
    notice('');
    root.querySelector('.vm-intro').hidden = true;
    editor.hidden = true;
    preview.hidden = false;
    persist(true);
    track('visit_memo_complete');
    if (focus) document.getElementById('vm-preview-title').focus();
  }
  function renderPhotos(container, editable) {
    container.replaceChildren();
    photos.forEach((src, index) => {
      const figure = document.createElement('figure');
      const image = document.createElement('img');
      image.src = src;
      image.alt = `添付写真 ${index + 1}`;
      figure.append(image);
      if (editable) {
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '削除';
        remove.setAttribute('aria-label', `写真${index + 1}を削除`);
        remove.addEventListener('click', () => {
          photos.splice(index, 1); renderPhotos(container, true); persist();
        });
        figure.append(remove);
      }
      container.append(figure);
    });
  }

  function restore() {
    try {
      const draft = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!draft) return;
      if (draft.expiresAt < Date.now() || !draft.expiresAt ||
          (draft.owner && draft.owner !== root.dataset.userId)) {
        sessionStorage.removeItem(storageKey);
        notice('期限切れ、またはアカウントが変わったため一時メモを消去しました。');
        return;
      }
      if (!/^[a-f0-9]{32}$/.test(draft.requestId)) throw new Error('Invalid draft');
      requestId = draft.requestId;
      expiresAt = draft.expiresAt;
      Object.entries(draft.values || {}).forEach(([key, value]) => {
        const input = form.elements.namedItem(key);
        if (input && typeof value === 'string') input.value = value;
      });
      photos = (draft.photos || []).filter(src => typeof src === 'string' && /^data:image\/jpeg;base64,/.test(src)).slice(0, 3);
      renderPhotos(document.getElementById('vm-photo-list'), true);
      notice('このタブの入力内容を復元しました。');
      if (draft.isPreview) showPreview(false);
    } catch (_) {
      notice('一時メモを復元できませんでした。入力内容を確認してください。');
    }
  }

  form.addEventListener('input', () => { start(); persist(false); });
  form.addEventListener('submit', event => { event.preventDefault(); showPreview(); });
  document.getElementById('vm-edit').addEventListener('click', () => {
    root.querySelector('.vm-intro').hidden = false;
    preview.hidden = true; editor.hidden = false; persist(false);
    document.getElementById('vm-concern').focus();
  });
  document.getElementById('vm-clear').addEventListener('click', () => {
    if (!window.confirm('入力内容と写真を、このタブから消去しますか？')) return;
    photoVersion += 1; photoBusy = false;
    form.reset(); photos = []; requestId = randomId(); expiresAt = Date.now() + ttl;
    try { sessionStorage.removeItem(storageKey); } catch (_) { /* Storage may be disabled. */ }
    renderPhotos(document.getElementById('vm-photo-list'), true);
    notice('入力内容を消去しました。');
  });
  const petSelect = document.getElementById('vm-pet-id');
  if (petSelect) petSelect.addEventListener('change', () => {
    const name = petSelect.selectedOptions[0].dataset.name;
    if (name) document.getElementById('vm-name').value = name;
    persist(false);
  });
  photoInput.addEventListener('change', async () => {
    const files = Array.from(photoInput.files);
    if (files.length > 3 || files.some(file => !['image/jpeg', 'image/png'].includes(file.type) || file.size > 5 * 1024 * 1024)) {
      notice('写真はJPEG・PNG、3枚まで、1枚5MB以内で選んでください。'); photoInput.value = ''; return;
    }
    const version = ++photoVersion;
    photoBusy = true;
    notice('写真を準備しています。');
    try {
      const converted = await Promise.all(files.map(resizePhoto));
      if (version !== photoVersion) return;
      photos = converted;
      renderPhotos(document.getElementById('vm-photo-list'), true);
      notice('写真を追加しました。手帳には文章のみ保存されます。');
      persist(false);
    } catch (_) { notice('読み込めない写真がありました。別のJPEG・PNGを選んでください。'); }
    finally { if (version === photoVersion) photoBusy = false; photoInput.value = ''; }
  });
  document.querySelectorAll('#vm-auth form').forEach(authForm => {
    authForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (!persist(true) && !window.confirm('一時保存できないため、移動するとメモを失う可能性があります。登録・ログインへ進みますか？')) return;
      await eventQueue;
      authForm.submit();
    });
  });
  document.getElementById('vm-save').addEventListener('click', async () => {
    if (saving) return;
    saving = true;
    const button = document.getElementById('vm-save');
    button.disabled = true; notice('保存しています。');
    try {
      await eventQueue.catch(() => {});
      const response = await send(root.dataset.saveUrl, { visit_memo: { ...values(), request_id: requestId } });
      if (response.status === 401) {
        document.getElementById('vm-auth').hidden = false;
        button.hidden = true;
        throw new Error('ログインの有効期限が切れました。入力内容を残してログインし直してください。');
      }
      if (response.status === 422) {
        const data = await response.json(); throw new Error((data.errors || ['入力内容を確認してください。']).join(' '));
      }
      if (!response.ok) throw new Error('保存できませんでした。入力内容は残っています。時間をおいて再度お試しください。');
      const data = await response.json();
      try { sessionStorage.removeItem(storageKey); } catch (_) { /* Do not mask a successful save. */ }
      window.location.assign(data.url);
    } catch (error) {
      notice(error.name === 'AbortError' ? '通信がタイムアウトしました。内容は残っています。再度保存をお試しください。' :
        error.message || '通信できませんでした。入力内容は残っています。');
    }
    finally { saving = false; button.disabled = false; }
  });
  restore();
}

function randomId() {
  return Array.from(crypto.getRandomValues(new Uint8Array(16))).map(byte => byte.toString(16).padStart(2, '0')).join('');
}

function resizePhoto(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const photo = new Image();
    photo.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Invalid image')); };
    photo.onload = () => {
      try {
        const ratio = Math.min(1, 1000 / Math.max(photo.width, photo.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(photo.width * ratio));
        canvas.height = Math.max(1, Math.round(photo.height * ratio));
        const context = canvas.getContext('2d');
        context.fillStyle = '#fff'; context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(photo, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', 0.8));
      } catch (error) { reject(error); }
      finally { URL.revokeObjectURL(url); }
    };
    photo.src = url;
  });
}
